<template>
  <Gallery/>
</template>

<script>
import Gallery from '../components/Gallery';
export default {
components: {
    Gallery,
}
}
</script>

<style>

</style>